import { PortalRole } from './portal-role.service';

export function portalHomeCommands(role: PortalRole | undefined | null): string[] {
  if (role === 'TINYPROMO_OPS') {
    return ['/base/promo-managed-cases'];
  }
  if (role === 'ADMIN' || role === 'OPS') {
    return ['/base/dashboard'];
  }
  return ['/sign-in'];
}

export function roleCanOpen(role: PortalRole | undefined | null, allowed: PortalRole[]): boolean {
  return !!role && allowed.indexOf(role) >= 0;
}

/** TinyPromo Ops menu stays inside Admin. The customer app does not host these screens for an Admin session. */
export function buildPortalNav(role: PortalRole | undefined | null, production: boolean): any[] {
  if (role === 'TINYPROMO_OPS') {
    return tinyPromoNavItems();
  }

  if (role === 'OPS') {
    return [
      { label: 'Dashboard', icon: 'pi pi-fw pi-chart-line', routerLink: ['dashboard'] },
      { label: 'Hubs', icon: 'pi pi-fw pi-list', routerLink: ['hubs'] },
      { label: 'Subscriptions', icon: 'pi pi-fw pi-money-bill', routerLink: ['subscriptions'] },
    ];
  }

  const usersMenuItems: any[] = [
    { label: 'Users', icon: 'pi pi-fw pi-users', routerLink: ['users'] },
  ];
  if (!production) {
    usersMenuItems.push({
      label: 'Test Users',
      icon: 'pi pi-fw pi-file',
      routerLink: ['testusers'],
    });
  }
  usersMenuItems.push({
    label: 'User Roles',
    icon: 'pi pi-fw pi-id-card',
    routerLink: ['portal-operators'],
  });

  return [
    { label: 'Dashboard', icon: 'pi pi-fw pi-chart-line', routerLink: ['dashboard'] },
    {
      label: 'Hubs',
      icon: 'pi pi-fw pi-file',
      items: [
        { label: 'Hubs', icon: 'pi pi-fw pi-list', routerLink: ['hubs'] },
        { label: 'Hub Orders', icon: 'pi pi-fw pi-file', routerLink: ['orders'] },
        { label: 'Subscriptions', icon: 'pi pi-fw pi-money-bill', routerLink: ['subscriptions'] },
      ],
    },
    { label: 'Users', icon: 'pi pi-fw pi-users', items: usersMenuItems },
    { label: 'Abuse Reports', icon: 'pi pi-fw pi-exclamation-triangle', routerLink: ['abuses'] },
    {
      label: 'Promo Codes',
      icon: 'pi pi-fw pi-ticket',
      items: [
        { label: 'Codes', icon: 'pi pi-fw pi-ticket', routerLink: ['promos'] },
        { label: 'Usage Logs', icon: 'pi pi-fw pi-list', routerLink: ['promocodelogs'] },
      ],
    },
    { label: 'TinyPromo', icon: 'pi pi-fw pi-ticket', items: tinyPromoNavItems() },
    { label: 'Login Logs', icon: 'pi pi-fw pi-list', routerLink: ['logs'] },
    { label: 'Visitor Sessions', icon: 'pi pi-fw pi-desktop', routerLink: ['visitor-sessions'] },
    {
      label: 'Delivery Network',
      icon: 'pi pi-fw pi-truck',
      items: [
        { label: 'Delivery Partners', icon: 'pi pi-fw pi-users', routerLink: ['delivery-partners'] },
        { label: 'Delivery Assignments', icon: 'pi pi-fw pi-list', routerLink: ['delivery-assignments'] },
        { label: 'Fee Ledger', icon: 'pi pi-fw pi-money-bill', routerLink: ['delivery-fee-ledger'] },
        { label: 'Hub Network', icon: 'pi pi-fw pi-sitemap', routerLink: ['delivery-hub-network'] },
        { label: 'Rate Policy', icon: 'pi pi-fw pi-sliders-h', routerLink: ['delivery-rate-policy'] },
      ],
    },
    { label: 'Platform Settings', icon: 'pi pi-fw pi-cog', routerLink: ['platform-settings'] },
  ];
}

function tinyPromoNavItems(): any[] {
  return [
    { label: 'TinyPromo Cases', icon: 'pi pi-fw pi-ticket', routerLink: ['promo-managed-cases'] },
    { label: 'TinyPromo Commissions', icon: 'pi pi-fw pi-money-bill', routerLink: ['promo-commissions'] },
  ];
}

export function navUsesCustomerApp(items: any[]): boolean {
  return items.some((item) => {
    if (item?.url) {
      return true;
    }
    return Array.isArray(item?.items) && navUsesCustomerApp(item.items);
  });
}
